import React, { useEffect, useState } from "react";
import { Timeline } from "primereact/timeline";

import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../App.css";

import ReminderApi from "../Apis/ReminderApi";

const formatTriggerType = (triggerType) => {
  if (!triggerType) return "-";
  return triggerType.replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
};

const ReminderHistory = ({ triggerFor, triggerId }) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);

  const getReminderHistory = async () => {
    if (!triggerId) return;
    setLoading(true);
    try {
      const response = await ReminderApi.getRemindersHistory(triggerFor, triggerId);
      setEvents(response?.data?.reminders || []);
    } catch (error) {
      console.error("Error fetching reminder history:", error);
      setEvents([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getReminderHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerFor, triggerId]);

  return (
    <div className="bg-white rounded-[10px] border py-5 border-slate-200 w-full">
      {loading && (
        <div className="text-center text-gray-500 text-sm py-4">Loading...</div>
      )}
      {!loading && events.length === 0 && (
        <div className="text-center text-gray-500 text-sm py-4">No reminder history available</div>
      )}
      {!loading && events.length > 0 && (
        <div className="w-full">
          <Timeline
            className="px-10 xl:px-1 mt-6"
            value={events}
            opposite={(item) => (
              <small className="text-primary font-semibold w-full">
                {item.triggerDate} {item.triggerTimeFormatted}
              </small>
            )}
            content={(item) => (
              <div className="text-gray-600">
                <div className="font-semibold">
                  {formatTriggerType(item.triggerType)}
                  {item.triggerType === "SNOOZE" && item.remainderInMinutes
                    ? ` (${item.remainderInMinutes} min)`
                    : ""}
                </div>
                {item.reason && <div className="text-sm">{item.reason}</div>}
              </div>
            )}
            marker={() => (
              <span className="w-4 h-4 border-2 border-primary rounded-full bg-white"></span>
            )}
          />
        </div>
      )}
    </div>
  );
};

export default ReminderHistory;
